<div class="popup-overlay" *ngIf="showSharesPopup()">
  <div class="popup-container">

    <div class="popup-header">
      <h2>Distribute Beneficiary Shares</h2>
      <p class="shares-pool">
        Total Available Shares: <strong>{{ maxShares() }}%</strong>
      </p>
    </div>

    <div class="popup-body">
      <form [formGroup]="sharesForm">
        <div formArrayName="beneficiaries" class="beneficiaries-list">

          <div *ngFor="let control of beneficiariesFormArray.controls; let i = index" [formGroupName]="i"
            class="beneficiary-row">

            <div class="name-display">
              {{ control.get('name')?.value }}
            </div>

            <mat-form-field appearance="outline" class="share-input-field">
              <mat-label>Shares</mat-label>
              <input 
                matInput
                type="number" 
                formControlName="PercShare" 
                [min]="minShares()" 
                [max]="TOTAL_POOL"
                placeholder="0"
              />
              <span matSuffix class="unit-suffix">%</span>
            </mat-form-field>

            <div class="error-message" *ngIf="control.get('PercShare')?.invalid && control.get('PercShare')?.touched">
              <small *ngIf="control.get('PercShare')?.errors?.['required']">Share allocation required.</small>
              <small *ngIf="control.get('PercShare')?.errors?.['min']">Minimum allocated share is {{ minShares()
                }}%.</small>
              <small *ngIf="control.get('PercShare')?.errors?.['max']">Exceeds remaining available pool!</small>
            </div>

          </div>

        </div>
      </form>
    </div>

    <div class="popup-footer">
      <button type="button" class="btn-secondary" (click)="closePopup()">Cancel</button>
      <button type="button" class="btn-primary" [disabled]="sharesForm.invalid || maxShares() < 0"
        (click)="updateBeneficiariesShares()">
        Save Allocations
      </button>
    </div>

  </div>
</div>